import React, { SVGAttributes, SVGProps } from "react";
import * as defaultClasses from "../styles/icon.module.scss";
import { motion } from "framer-motion";
import { IconPack } from "../utils/icons";
interface IIcon {
  name: string;
  classes?: {
    root?: string;
  };
  color?: string;
  svgAttributes?: SVGProps<SVGElement>;
}
const iconPaths = IconPack["icons"];
export const Icon: React.FC<IIcon> = ({
  name,
  classes: propClasses,
  color,
  svgAttributes,
}) => {
  // Fallback in case you pass the wrong name
  const iconFallback = iconPaths["search"];
  // const iconFallback = iconPaths["question-outline"];

  const path =
    iconPaths[name] == null ? iconFallback.path : iconPaths[name].path;

  const viewBox =
    (iconPaths[name] == null
      ? iconFallback.viewBox
      : iconPaths[name].viewBox) || "0 0 24 24";

  const classes = Object.assign(defaultClasses, propClasses);

  return (
    <motion.svg
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      className={classes.root}
      viewBox={svgAttributes?.viewBox ?? viewBox}
      color={color}
      style={{ width: svgAttributes?.width, height: svgAttributes?.height }}
    >
      {path}
    </motion.svg>
  );
};

export default Icon;
